<template>
    <div class="echarts-block">
        <div
            class="echarts-block-echarts-container"
            id="echarts-block-echarts-container"
            v-auto-size
        ></div>
        <div class="earth" @click="handleBack" :title="backTitle"></div>
    </div>
</template>

<script>
import { getRelativelySize } from '@/utils/size'
import * as fcScreenAPI from '@/api/fc-screen'
import store from '@/utils/store'
import eventHub from '@/utils/eventHub'
import { STORE_AREA_INFO_KEY } from '@/constans/common'

/**
 * 地图
 */
export default {
    echartsInstance: null,
    mapMappingList: null,
    currentMapInfo: null,
    currentMapEchartId: null,
    isInit: false,
    initMapInfo: null,
    destroyed() {
        if (this.echartsInstance) {
            this.echartsInstance.dispose()
        }
    },
    data: function() {
        return {
            backTitle: '',
            backMapTitle: ''
        }
    },
    mounted() {
        eventHub.$on('areaChange', () => {
            if (!this.isInit) {
                this.isInit = true
                this.getEachrtInfo()
            }
        })
        this.init()
        let arr = sessionStorage.getItem('list')
            ? JSON.parse(sessionStorage.getItem('list'))
            : []
        if (arr.length === 3) {
            this.backMapTitle = `查看 ${arr[1].echartLocName} 数据`
        } else if (arr.length === 2) {
            this.backMapTitle = `查看 ${arr[0].echartLocName} 数据`
        } else {
            this.backMapTitle = ''
        }
    },
    methods: {
        registerMap(name, json) {
            if (!echarts.getMap(name)) {
                echarts.registerMap(name, json)
            }
        },
        getOptions() {
            const options = {
                geo: {
                    show: true,
                    map: this.currentMapInfo.echartLocId,
                    aspectScale: 1,
                    zoom: 1.26,
                    itemStyle: {
                        borderWidth: getRelativelySize(1),
                        borderColor: 'rgba(0,0,0,0)',
                        shadowBlur: getRelativelySize(10),
                        shadowColor: '#030B20',
                        shadowOffsetX: getRelativelySize(5),
                        shadowOffsetY: getRelativelySize(5)
                    }
                },
                series: [
                    {
                        type: 'map',
                        map: this.currentMapInfo.echartLocId,
                        aspectScale: 1,
                        zoom: 1.26,
                        itemStyle: {
                            areaColor: '#005AA3',
                            borderWidth: getRelativelySize(1),
                            borderType: 'solid',
                            borderColor: '#33A7ef'
                        },
                        label: {
                            normal: {
                                show: true,
                                color: '#C1EFFC',
                                fontSize: '12px'
                            }
                        },
                        emphasis: {
                            label: {
                                show: true,
                                color: '#000'
                            },
                            itemStyle: {
                                areaColor: '#51B6EC'
                            }
                        }
                    }
                ]
            }
            return options
        },
        init() {
            if (this.echartsInstance) return
            const charInstance = echarts.init(
                document.getElementById('echarts-block-echarts-container')
            )
            charInstance.on('click', (e) => this.handleMapClick(e))
            charInstance.on('mouseOver', (e) => {
                e.innerHTML = ''
            })
            this.echartsInstance = charInstance
        },
        async handleMapClick(params) {
            const { name } = params
            // 根据名字在地图信息中查找对应的 id
            let features = echarts.getMap(this.currentMapInfo.echartLocId)
                .geoJson.features
            let echartId = null

            for (let i = 0; i < features.length; i++) {
                if (features[i].properties.name === name) {
                    echartId = features[i].properties.id
                    break
                }
            }
            if (echartId) {
                const currentMapInfo = this.findAreaInfoByKey(echartId)
                if (currentMapInfo) {
                    this.triggerChange(currentMapInfo)
                } else {
                    console.error(`未找到 ${name} ${echartId} 信息。`)
                }
            } else {
                console.error(`未找到映射关系: ${name}`)
            }
        },
        handleBack() {
            // 当前选中不是初始地图则显示初始数据
            if (this.currentMapEchartId !== this.initMapInfo.echartLocId) {
                this.triggerChange(this.initMapInfo)
            }
        },
        triggerChange(currentMapInfo) {
            // 修改标题
            if (currentMapInfo.echartLocName) {
                eventHub.$emit('titleChange', currentMapInfo.echartLocName)
            }
            this.currentMapEchartId = currentMapInfo.echartLocId

            const options = this.getOptions()
            this.echartsInstance.setOption(options)

            eventHub.$emit('areaChange', currentMapInfo.id)
        },
        /**
         * 查找地区信息
         * @param id {string|number} echartLocId 或者 tuLiuLocId，
         * @param isTid {boolean} 是否是 tid，默认 false
         */
        findAreaInfoByKey(id, isTid) {
            const tuLiuLocId = store.getValue(STORE_AREA_INFO_KEY).tuLiuLocId
            for (let i = 0; i < this.mapMappingList.length; i++) {
                const item = this.mapMappingList[i]
                if (isTid) {
                    // 因为是老接口，不能动， 所以写死了
                    return {
                        echartLocId: tuLiuLocId,
                        echartLocName: '丰城',
                        tuLiuLocId: tuLiuLocId
                    }
                } else {
                    if (+item.echartLocId === +id) {
                        return item
                    }
                }
            }

            return null
        },
        /**
         * 获取地图信息
         */
        async getEachrtInfo() {
            const tuLiuLocId = store.getValue(STORE_AREA_INFO_KEY).tuLiuLocId
            const params = {
                locCounty: tuLiuLocId
            }
            const response = await fcScreenAPI.mapAreaInfo(params)
            let arr = response.data ? response.data : []
            let newArr = []
            for (let i = 0; i < arr.length; i++) {
                let obj = {
                    id: arr[i].id,
                    echartLocName: arr[i].name,
                    echartLocId: arr[i].id
                }
                newArr.push(obj)
            }

            this.mapMappingList = newArr

            const info = (this.currentMapInfo = this.findAreaInfoByKey(
                tuLiuLocId,
                true
            ))
            const errorHandle = () => {
                console.error(`请求 JSON错误: ${info.echartLocId}`)
            }

            if (info) {
                this.initMapInfo = info

                if (info.echartLocName) {
                    // 修改文档标题
                    eventHub.$emit('titleChange', info.echartLocName)

                    // 设置返回按钮标题
                    this.backTitle = `查看 ${info.echartLocName} 数据`
                }

                try {
                    /**
                     * 拉取地图 JSON 数据进行地图渲染
                     */
                    const responseJSON = await fcScreenAPI.getMapJSON(
                        info.echartLocId
                    )
                    if (responseJSON.status === 200) {
                        const mapJSON = responseJSON.data
                        this.registerMap(info.echartLocId, mapJSON)
                        const options = this.getOptions()
                        this.echartsInstance.setOption(options)
                    } else {
                        errorHandle()
                    }
                } catch (e) {
                    errorHandle()
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.echarts-block {
    height: 850px;
    display: flex;
    align-items: center;
    position: relative;
    .tab-data {
        padding: 10px 0;
        button {
            border: 0 solid #33a7f0;
            box-shadow: 0 0 3px 2px rgba(70, 102, 255, 0.5);
            font-size: 15.12px;
            line-height: 16px;
            color: #33a7f0;
            outline: none;
            background: none;
            padding: 10px 70px;
            cursor: pointer;
            position: relative;
            &.is-active {
                color: #ffffff;
                background: #33a7f0;
                box-shadow: 0 0 3px 2px rgba(70, 102, 255, 0.5);
            }
        }
    }
    .echarts-block-echarts-container {
        width: 100%;
        height: 100%;
    }
    .trading-situation {
        width: 100%;
    }
    > .earth {
        width: 45px;
        height: 63px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url('../../../assets/images/earth@2x.png');
        position: absolute;
        top: 20px;
        right: 21px;
        cursor: pointer;
        &.map-back {
            height: 45px;
            background-image: url('../../../assets/images/back.png');
            left: 20px;
        }
    }
}
</style>
